
import {checkIfItIsEmpty} from
    "./../checks/checkIfItIsEmpty.js"; 

export function changeIfEmpty(itemOne, itemTwo){
	
	if( checkIfItIsEmpty(itemOne) ){

		return itemTwo;

	}else{

		return itemOne;
	};


};
